import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import MenuService from 'services/system/MenuService'
import Utils from 'utils'

export const initialState = {
  loading: false,
  message: '',
  fetchLoading: false,
  disabled: {},
  hidden: {},
  handleClick: {},
  list: [],
  buttonValue: '',
}

export const selectMenuButtonListByAuthorities = createAsyncThunk(
  'menu/select-menu-button-list-by-authorities',
  async (data, { rejectWithValue }) => {
    const response = await MenuService.selectMenuButtonListByAuthorities()

    if (response) {
      return response
    } else {
      return rejectWithValue(response.message)
    }
  },
)

export const menuButtonSlice = createSlice({
  name: 'menuButton',
  initialState,
  reducers: {
    onHandelClick: (state, action) => {
      state.handleClick = {
        ...state.handleClick,
        ...action.payload,
      }
    },
    onButtonLoding: (state, action) => {
      state.fetchLoading = action.payload
    },
    onButtonDisabled: (state, action) => {
      state.disabled = {
        ...state.disabled,
        ...action.payload,
      }
    },
    onButtonHidden: (state, action) => {
      state.hidden = {
        ...state.hidden,
        ...action.payload,
      }
    },
    onButtonClear: (state, action) => {
      if (Utils.isEmpty(action.payload)) {
        state.disabled = {}
        state.hidden = {}
      } else {
        Object.keys(state.disabled).forEach(key => {
          if (key.startsWith(action.payload)) {
            delete state.disabled[key] // 해당 키 삭제
          }
        })

        Object.keys(state.hidden).forEach(key => {
          if (key.startsWith(action.payload)) {
            delete state.hidden[key] // 해당 키 삭제
          }
        })
      }
    },
    setButtonValue: (state, action) => {
      state.buttonValue = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(selectMenuButtonListByAuthorities.pending, state => {
        state.loading = true
      })
      .addCase(selectMenuButtonListByAuthorities.fulfilled, (state, action) => {
        state.loading = false
        state.list = action.payload
      })
      .addCase(selectMenuButtonListByAuthorities.rejected, (state, action) => {
        state.message = action.payload
        state.loading = false
      })
  },
})

export const { onHandelClick, onButtonLoding, onButtonDisabled, onButtonHidden, onButtonClear, setButtonValue } =
  menuButtonSlice.actions

export default menuButtonSlice.reducer
